var _defs, _tspan, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCwd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "132.29167mm",
    height: "55.36375mm",
    viewBox: "0 0 132.29167 55.36375",
    id: "svg94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-9.0826126e-7,-241.63626)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 117.83928,
    id: "text98"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan100",
    x: 16.630953,
    y: 127.62886
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 111.03571,
    id: "text104"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan102",
    x: 16.630953,
    y: 158.02571,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE0A2 \\uE1E7",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "120.26547241px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    id: "text108",
    transform: "matrix(2.3017303,0,0,2.3017303,-1.1823112e-6,-340.10826)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 20.805928,252.74226 C 7.9375221,252.74226 9.0826126e-7,258.03394 9.0826126e-7,264.52828 c 0,6.49434 5.53221169173874,12.26708 19.84380309173874,12.26708 15.754777,0 20.805927,-5.53221 20.805927,-12.26708 0,-6.73487 -10.944158,-11.78602 -19.843803,-11.78602 z m -10.1023,6.01328 c 1.082389,-3.36744 4.570088,-3.8485 7.576725,-3.8485 6.614601,0 11.906281,7.09567 11.906281,12.86841 0,0.60133 -0.120265,1.20265 -0.120265,1.80398 -0.481062,2.40531 -1.924248,4.08903 -4.329557,4.57009 -0.962124,0.36079 -1.924248,0.48106 -2.886371,0.48106 -0.962124,0 -1.683717,-0.12027 -2.525575,-0.48106 -1.683717,-0.48106 -3.247168,-1.32292 -4.570088,-2.40531 -0.721593,-0.72159 -1.443186,-1.44319 -2.044513,-2.16478 -1.924248,-2.16478 -3.367433,-5.53221 -3.367433,-8.53885 0,-0.84186 0.120265,-1.56345 0.360796,-2.28504 z",
    id: "path204"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 57.474878,264.76881 c 0,-2.64584 -2.164779,-4.81062 -4.810619,-4.81062 -2.64584,0 -4.810619,2.16478 -4.810619,4.81062 0,2.64584 2.164779,4.81062 4.810619,4.81062 2.64584,0 4.810619,-2.16478 4.810619,-4.81062 z",
    id: "path206"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCwd);
export default __webpack_public_path__ + "static/media/cwd.73b04a2492c9e31aa9c9953798618506.svg";
export { ForwardRef as ReactComponent };